/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, Output, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {DropdownOptionModel} from '../models/dropdown-option.model';

@Component({
    selector: 'app-description-dropdown',
    templateUrl: './select-in-table-dropdown.component.html',
    styleUrls: ['./select-in-table-dropdown.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectInTableDropdownComponent {

    @Output() selectedOption = new EventEmitter<DropdownOptionModel>();
    @Input() dropdownOptions: DropdownOptionModel[];
    @Input() dropdownTooltip: TemplateRef<any>;
    @Input() showDescription: boolean;
    @Input() useCodeOrName: 'code' | 'name' = 'code';

    selectOption(option: DropdownOptionModel): void {
        this.selectedOption.emit(option);
    }

    visualCode(option: DropdownOptionModel): string {
        let visualCode: string;

        switch (this.useCodeOrName) {
            case 'code':
                visualCode = option?.code;
                break;
            case 'name':
                visualCode = option?.name;
                break;
        }

        return visualCode;
    }

    optionHasTooltip(option: DropdownOptionModel): boolean {
        return option?.tooltip != null;
    }
}
